import { Spin } from 'antd';

export const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <Spin size="large" />
  </div>
);
